// This file was auto-generated by Fern from our API Definition.
/** How the gateway authenticates to an upstream. */
export const GatewayAuthScheme = {
    Oauth: "oauth",
    ApiKey: "api_key",
    None: "none",
};
